import { Edit } from '@mui/icons-material';
import { Divider, Stack } from '@mui/material';
import _ from 'lodash';
import { useEffect, useState } from 'react';
import LosButton from '../../../../../onboarding/components/common/LosButton';
import { useColenders } from '../../../../providers/ColendersProvider';
import ColenderInterestSchemeForm from '../Forms/ColenderInterestSchemeForm';

enum ViewState {
  ReadOnly,
  Edit,
}

type FormData = {
  interestValue: string;
  interestType: string;
  accrualMethod: string;
  presicion: string;
};

function ColenderInterestSchemeTab() {
  const {
    fetchColenderInterestScheme,
    selectedColender,
    saveColenderInterestScheme,
  } = useColenders();
  const [viewState, setViewState] = useState<ViewState>(ViewState.ReadOnly);
  const [formData, setFormData] = useState<Partial<FormData>>({});
  const [loading, setLoading] = useState<boolean>(false);

  function updateViewState(viewState: ViewState) {
    setViewState(viewState);
  }

  function handleUpdate(type: string, value?: string) {
    setFormData((prev) => {
      return {
        ...prev,
        [type]: value,
      };
    });
  }

  async function fetchDetails() {
    setLoading(true);
    setFormData({});
    const id = selectedColender?.id;
    if (!id) return;
    const response = await fetchColenderInterestScheme(id);
    setFormData(response);
    setLoading(false);
  }

  async function onSubmit() {
    setLoading(true);
    const id = selectedColender?.id;
    if (!id) return;
    await saveColenderInterestScheme({
      colenderId: id,
      formData: formData,
    });
    updateViewState(ViewState.ReadOnly);
    setLoading(false);
  }

  useEffect(() => {
    fetchDetails();
    updateViewState(ViewState.ReadOnly);
  }, [selectedColender]);

  return (
    <div
      style={{
        padding: '12px',
      }}
    >
      <ColenderInterestSchemeForm
        formData={formData}
        handleUpdate={handleUpdate}
        isEditable={viewState == ViewState.Edit}
      />
      <Divider
        style={{
          marginTop: '1rem',
          marginBottom: '1rem',
        }}
      />
      <Stack
        direction={'row'}
        justifyContent="end"
        alignItems={'center'}
        spacing={'1rem'}
        display={viewState == ViewState.ReadOnly ? 'flex' : 'none'}
      >
        <LosButton
          startIcon={<Edit />}
          text="Edit"
          variant="outlined"
          size="small"
          onClick={() => {
            updateViewState(ViewState.Edit);
          }}
        />
      </Stack>
      <Stack
        direction={'row'}
        justifyContent="end"
        alignItems={'center'}
        spacing={'1rem'}
        display={viewState == ViewState.Edit ? 'flex' : 'none'}
      >
        <LosButton
          size="small"
          text="Save"
          variant="outlined"
          onClick={onSubmit}
        />
        <LosButton
          text="Cancel"
          size="small"
          variant="outlined"
          onClick={() => {
            updateViewState(ViewState.ReadOnly);
          }}
        />
      </Stack>
    </div>
  );
}

export default ColenderInterestSchemeTab;
